// extracted by mini-css-extract-plugin
export var button = "_dj-0";
export var icon = "_dj-1";